import React from "react";
import { Container, Typography, Box } from "@mui/material";

const AvisoPrivacidad_En = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Privacy Notice – Emoji Surveys
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: April 2026
      </Typography>

      <Box mt={3}>
        <Typography paragraph>
          Emoji Surveys ("we", "our", or "us") provides a platform designed to capture customer satisfaction through interactive emoji-based surveys. We are committed to protecting your personal data and ensuring transparency regarding how your information is collected, used, and safeguarded.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Information We Collect
        </Typography>
        <Typography paragraph>
          We collect personal information that you voluntarily provide when creating an account. This includes your name and email address, which are required for authentication and account management. We do not collect phone numbers, precise location data (such as GPS or IP tracking), or sensitive personal data.
        </Typography>
        <Typography paragraph>
          If you choose to subscribe to a paid plan, payment processing is handled securely by third-party providers such as Stripe. We do not store or have direct access to your full payment details.
        </Typography>

        <Typography variant="h6" gutterBottom>
          How We Collect Information
        </Typography>
        <Typography paragraph>
          Your information is collected directly from you through registration forms or through authentication providers such as Google Sign-In. We do not use cookies for tracking purposes, nor do we collect data through external APIs for analytics or marketing.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Use of Information
        </Typography>
        <Typography paragraph>
          The information we collect is used solely for the purpose of providing and improving our services. This includes creating and managing user accounts, enabling access to the platform, processing subscription payments when applicable, and sending service-related communications such as account notifications.
        </Typography>
        <Typography paragraph>
          We do not use your personal data for marketing purposes, nor do we perform behavioral analytics or profiling.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Data Sharing
        </Typography>
        <Typography paragraph>
          We only share your data with trusted third-party service providers necessary for the operation of the platform. This includes Stripe for payment processing and Google Firebase for hosting, authentication, and database services. These providers process data in accordance with their own privacy and security standards.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Data Storage and International Transfers
        </Typography>
        <Typography paragraph>
          Your information is stored on cloud infrastructure provided by Google Firebase, which may be located outside of your country of residence, including in the United States. By using our services, you acknowledge and consent to such international data transfers.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Data Security
        </Typography>
        <Typography paragraph>
          We implement appropriate technical and organizational measures to protect your personal data. These include secure HTTPS connections, authentication mechanisms, and security rules enforced within our cloud infrastructure.
        </Typography>

        <Typography variant="h6" gutterBottom>
          User Rights
        </Typography>
        <Typography paragraph>
          You have the right to access, update, or correct your personal information at any time through your account. If you have an active subscription, you may cancel it at your discretion. These rights are aligned with applicable data protection laws.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Session Management
        </Typography>
        <Typography paragraph>
          User sessions are securely managed through Firebase Authentication to ensure safe access to the platform.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Changes to This Privacy Notice
        </Typography>
        <Typography paragraph>
          We reserve the right to update this Privacy Notice from time to time. Any significant changes will be communicated to users via their registered email address.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Contact
        </Typography>
        <Typography paragraph>
          If you have any questions about this Privacy Notice or how your data is handled, you may contact us at: emojisurveypro@gmail.com
        </Typography>
      </Box>
    </Container>
  );
};

export default AvisoPrivacidad_En;